import {Component, HostListener} from '@angular/core';

import {CloseGuard, DialogRef, ModalComponent} from 'ngx-modialog';
import {BSModalContext} from 'ngx-modialog/plugins/bootstrap';

export class AlertModalComponentContext extends BSModalContext {
    public titulo: string;
    public descricao: string;
    onOk : any
}

/**
 * A Sample of how simple it is to create a new window, with its own injects.
 */
@Component({
    selector: 'modal-content',
    templateUrl :'./alert.component.html',
})
export class AlertModalComponent implements CloseGuard, ModalComponent<AlertModalComponentContext> {
    context: AlertModalComponentContext;
    enviado : boolean = false;

    @HostListener('document:keypress', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent) {
        if(event.key == 'Enter'){
            this.close();
        }
    }

    constructor(public dialog: DialogRef<AlertModalComponentContext>) {
        this.context = dialog.context;
        // dialog.setCloseGuard(this);
    }

    close(){
        this.context.onOk(this.dialog);
    }


    dismiss(){
        this.context.onOk(this.dialog);
    }

    beforeDismiss(): boolean {
        return true;
    }

    beforeClose(): boolean {
        return true;
    }
}
